const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "./../../../../framework/tools/scrollview/listview"
import ModelData, { PlayerIconData, IUserData, HallShowGameData } from "../../../public/model_data";
import Utility from "../../../../utility/utility";
import GameItemInfo from "./game_item_info";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import SceneManager from "../../../../manager/scene_manager";
import AppData from "../../../public/const/app_data";
import CustomUIStateSwitcher from "../../../public/ui/custom_ui_state_switcher";
import LoaclStorage from "../../../../manager/local_storage";
import ModuleManager from "../../../../framework/core/module_manager";
import PublicPlayerAvatar from "../../../public/component/public_player_avatar";


@ccclass
export default class PlayerIconView extends ViewBase {

    @property([cc.Node])
    titleSprite:cc.Node[] = [];

    //-----人物头像信息
    @property(cc.Node)
    playerIconNode:cc.Node = null;

    @property(cc.Node)
    clickIconNode:cc.Node = null;

    @property(cc.Sprite)
    playerIcon: cc.Sprite = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(cc.Node)
    select:cc.Node = null;

    //------人物基础信息
    @property(cc.EditBox)
    eidtorBox:cc.EditBox = null;

    @property(cc.Node)
    baseInfoNode:cc.Node = null;

    @property(cc.Label)
    baseInfoID:cc.Label = null;

    @property(cc.Sprite)
    baseInfoSprite:cc.Sprite = null;

    @property(cc.Label)
    mangguoMoney:cc.Label = null;

    @property(cc.Label)
    daibiMoney:cc.Label = null;

    @property(cc.Label)
    choumaMoney:cc.Label = null;

    @property(cc.Label)
    maxVectoryCM:cc.Label = null;

    @property(cc.Label)
    maxVectoryMG:cc.Label = null;

    @property(cc.Label)
    historyMaxCM:cc.Label = null;

    @property(cc.Label)
    historyMaxMG:cc.Label = null;

    @property(cc.Label)
    gamescm:cc.Label = null;
    @property(cc.Label)
    gamesmg:cc.Label = null;

    @property(cc.Node)
    photoNode:cc.Node = null;

    @property(cc.Node)
    cameraNode:cc.Node = null;

    @property([cc.Node])
    maxVectory:cc.Node[] = [];//0筹码 1芒果

    @property([cc.Node])

    history:cc.Node[] = [];

    @property([cc.Node])
    jushu:cc.Node[] = [];

    @property([cc.Node])
    myGold:cc.Node[] = [];

    @property(cc.Node)
    mask:cc.Node = null;

    @property(cc.ScrollView)
    gameScrollview:cc.ScrollView = null;

    @property(cc.Node)
    gameView:cc.Node = null;

    @property(cc.Node)
    gameContent:cc.Node = null;

    @property(cc.Node)
    gamePrefab:cc.Node = null;

    @property(cc.Label)
    lv:cc.Label = null;

    @property(cc.Label)
    exp:cc.Label = null;

    @property(cc.Node)
    sliderMask:cc.Node = null;

    @property(SpriteFrameHolder)
    smallGameIcon: SpriteFrameHolder = null;

    @property([cc.Node])
    maskNode:cc.Node[] = [];//0 女 1男

    @property(cc.Node)
    magicAnim:cc.Node = null;

    @property(cc.Node)
    otherMagics:cc.Node = null;

    @property(cc.Node)
    magics:cc.Node = null;

    @property(cc.Node)
    gameListNode:cc.Node = null;

    @property(cc.Node)
    changeNameNode:cc.Node = null;

    //other----
    @property(cc.Label)
    otherLv:cc.Label = null;

    @property(cc.Label)
    otherName:cc.Label = null;

    @property([cc.Node])
    otherSex:cc.Node[] = [];

    @property([cc.Node])
    openNode:cc.Node[] = [];//0 me 1 other

    @property(CustomUIStateSwitcher)
    switcher:CustomUIStateSwitcher = null;

    @property([cc.Node])
    friendBtn:cc.Node[] = [];

    @property(cc.Node)
    otherMagic:cc.Node = null;

    @property(cc.Node)
    bigIcon:cc.Node = null;

    @property(cc.Sprite)
    bigIconFrame:cc.Sprite = null;

    @property([cc.Node])
    vipNodes:cc.Node[] = [];//-1,2,3

    @property([cc.Node])
    grayNode:cc.Node [] = [];

    @property(CustomUIStateSwitcher)
    centerUISwitch:CustomUIStateSwitcher = null;

    @property([cc.Node])
    itemDes:cc.Node[] = [];


    @property(cc.Node)
    otherExpListView:cc.Node = null;

    @property(cc.Node)
    myExpListView:cc.Node = null;

    @property([cc.Node])
    editorNode:cc.Node[] = [];//0--active 1--deactive

    @property(cc.Node)
    centerNode:cc.Node = null;

    @property(PublicPlayerAvatar)
    player_avatar:PublicPlayerAvatar = null;

    private playerSprite:cc.SpriteFrame = null;

    protected listView: ListView = null;
    protected selectData: PlayerIconData = null;

    protected maleIcons;
    protected femaleIcons;

    protected gameListView: ListView = null;


    protected vipMap:Map<string,number> = null;

    cacheName:string = '';

    init () {
        this.listView = new ListView({
            scrollview: this.scrollView,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            item_click_ex_func: this.item_click_func,
            item_click_func:this.item_click_Node,
            column: 5,
            gap_y: 20,
            gap_x: 20,
            direction: ListViewDir.Vertical,
        });
        [this.maleIcons, this.femaleIcons]= ModelData.instance.getPlayerIcons();

        //gameList
        let list: ListView = new ListView({
            scrollview: this.gameScrollview,
            view: this.gameView,
            content: this.gameContent,
            item_prefab: this.gamePrefab,
            cb_host: this,
            item_update_func: this.update_game_item,
            gap_x:10,
            direction: ListViewDir.Horizontal,
        });
        this.gameListView = list

        this.vipMap = new Map<string,number>();
        this.vipMap.set('SYS_Vip_Scard',0);
        this.vipMap.set('SYS_Vip_Gcard',1);
        this.vipMap.set('SYS_Vip_Dcard',2);
        this.eidtorBox.node.on('editing-did-began',()=>{
            this.isActiveEditor(true);
        },this)
        this.eidtorBox.node.on('editing-return',()=>{
            this.isActiveEditor(false);
        },this)
        this.eidtorBox.node.on('editing-did-ended',()=>{
            this.isActiveEditor(false);
        },this)

        this.siwtchPanel('baseInfo');
    }
    onShow(arg0)
    {
        super.onShow(arg0)
        
        this.showBigIcon(false);
        this.photoNode.active = CC_JSB;
        this.cameraNode.active = CC_JSB;
        this.isActiveEditor(false);
    }
    refreshItemList(isMale:boolean)
    {
        if(isMale)
        {
            this.listView.set_data(this.maleIcons)
        }else
        {
            this.listView.set_data(this.femaleIcons)
        }
        this.listView.scroll_to(0);
        this.refreshPlayerIcon(this.playerSprite);
        this.resetIconPanelData();

    }

    //切换面版 
    siwtchPanel(panleType:string){
        let isPlayerNode = panleType == 'playerIcon';
        this.playerIconNode.active = isPlayerNode;//基础信息面版
        this.baseInfoNode.active = panleType == 'baseInfo';
        this.changeTitle(!isPlayerNode)
        this.updatePanel(panleType);
        this.changePanelFunc(panleType);
    }

    private isActiveEditor(isActive:boolean){
        this.editorNode[0].active = isActive;
        this.editorNode[1].active = !isActive;
    }

    private changePanelFunc(panleType:string){
        if (panleType == 'playerIcon') {
            if (this.playerSprite) {
                this.refreshPlayerIcon(this.playerSprite);
            }
        }
    }

    private changeTitle(isBaseNode:boolean){
        this.titleSprite[0].active = isBaseNode;
        this.titleSprite[1].active = !isBaseNode;
    }

    private updatePanel(panleType:string){
        if (panleType == 'playerIcon') {
            this.refreshItemList( this.maskNode[1].active)
        }
    }

    showPanelIsInGame(isInGame:boolean,isMe:boolean,isOtherPanel:boolean){
        this.magicAnim.active = isInGame && !isOtherPanel;
        this.gameListNode.active = !isInGame
        this.otherMagic.active = isOtherPanel && isInGame;
        //this.changeNameNode.active = !isInGame
        this.refreshForbid(isInGame ? true:!isMe)
        this.itemDes[0].active = isInGame //表情
        this.itemDes[1].active = !isInGame//游戏
    }

    refreshForbid(isShow){
        this.mask.active = isShow;
    }

    //0shangchu ,1 tianjia,2 yijshi
    refreshFriend(tag:number){
        this.friendBtn[0].active = tag == 0;//添加
        this.friendBtn[1].active = tag == 1;//删除
        this.friendBtn[2].active = tag == 2;//申请过
    }

    getMagics():cc.Node[]{
        return this.magics.children;
    }

    getOtherMagics():cc.Node[]{
        return this.otherMagics.children;
    }

    avatarSize():cc.Size{
        return this.playerIcon.node.getContentSize();
    }

    setSelectImage(texture:cc.Texture2D,data:any){
        let size = this.avatarSize();
        let frame = new cc.SpriteFrame(texture)
        frame.setOriginalSize(size)
        this.refreshPlayerIcon(frame);
        this.resetIconPanelData();
    }

    get isShowImage(){
        return this.playerIconNode.active;
    }

    private curSelect:cc.Node = null;

    item_click_Node(item:cc.Node){

        this.selectItem(item);

        if (this.curSelect) {
            if (this.curSelect == item) {
                this.select.active = !this.select.active;
            }else{
                this.select.active = true;
            }
        }else{
            this.select.active = true;
        }
        this.curSelect = item;
    }

    item_click_func(data: any) {
        if (this.select.active) {
            this.selectData = <PlayerIconData>data;
            if (this.selectData) {
                this.refreshPlayerIcon(this.selectData.iconRes);
            }
        }else{
            this.selectData = null;
        }
    }

    resetIconPanelData(){
        this.selectData = null;
        this.curSelect = null;
        this.select.active = false;
    }

    selectItem(node:cc.Node){
        if (node) {
            this.select.parent = node;
            this.select.position = cc.Vec3.ZERO;
        }
    }

    updateGameList(data:any){
        let gameList = data.gameHistoryList.concat([]);
   
        let getRound = (gameId:string)=>{
            for (let i = 0; i < gameList.length; i++) {
                let item = gameList[i];
                if (item.gameId == gameId) {
                    gameList.splice(i,1);
                    return item.totalRound;
                }
            }
            return 0;
        }


        let arry = [];
        let gameNames:HallShowGameData[]=ModelData.instance.gameDataShow
        for (let i = 0; i < gameNames.length; i++) {
            let item = gameNames[i];
            arry.push({gameId:item.gameId,totalRound:getRound(item.gameId)})
        }

        arry.sort((a:any,b:any)=>{
            return b.totalRound - a.totalRound;
        })

        this.gameListView.set_data(arry)
    }

    update_game_item(item: cc.Node, data: any, index: number): void {
        item.getComponent(GameItemInfo).refreshGameInfo(data,this.getIcon.bind(this));
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let _icon = cc.find('avatar/Mask/icon',item);
        let icon = _icon.getComponent<cc.Sprite>(cc.Sprite);
        icon.spriteFrame = data.iconRes;
    }

    getIcon(name:string):cc.SpriteFrame{
        return this.smallGameIcon.getSpriteFrameByKey(name);
    }

    getSelectData():[string, number]
    {
        if(this.selectData != null)
        {
            return [this.selectData.iconName, this.selectData.isMale?1: 2]
        }
        return [null,null];
    }

    refreshPlayerIcon(spriteFrame: cc.SpriteFrame)
    {
        if (!spriteFrame) {
            return;
        }
        this.playerIcon.spriteFrame = spriteFrame;
    }

    refreshPlayerBaseInfoIcon(spriteFrame: cc.SpriteFrame){
        if (!spriteFrame) {
            return;
        }
        this.baseInfoSprite.spriteFrame = spriteFrame;
    }

    refreshSelectPlayerIcon(){
        if (this.playerIcon) {
            this.refreshPlayerBaseInfoIcon(this.playerIcon.spriteFrame)
        }
    }

    showBigIcon(isShow:boolean){
        this.bigIcon.active = isShow;
        if (isShow && this.baseInfoSprite) {
           this.bigIconFrame.spriteFrame = this.baseInfoSprite.spriteFrame
        }
    }


    selectFirstHead(isMale:boolean):PlayerIconData{
        let spriteFrame = this.femaleIcons[0]
        if (isMale) {
            spriteFrame = this.maleIcons[0]
        }
        if (spriteFrame && spriteFrame.iconRes) {
            this.refreshPlayerBaseInfoIcon(spriteFrame.iconRes);
            this.refreshPlayerIcon(spriteFrame.iconRes);
            this.playerSprite = spriteFrame.iconRes;
        }
        return spriteFrame
    }

    isNeedBring():boolean{
        if (AppData.gameSimpleName == "DZPK" || AppData.gameSimpleName == "SLOT") {
            return true;
        }
        return false;
    }

    refreshPlayerMoney(currencyData: IUserCurrencyData){
        let gold = currencyData.chip;

        if (AppData.inTable) {
            if (this.isNeedBring()) {
                gold += currencyData.gameTableChip;
            }else{
                gold = currencyData.gameTableChip;
            }  
        }else{
            if (!Number.isNaN(currencyData.freez)) {
                gold += Number(currencyData.freez);
            }
        }

        let _gold = this.currencyFormatting(gold);
        let _chip = this.currencyFormatting(currencyData.chip);
        let _daibi = this.currencyFormatting(currencyData.daibi);
        _gold = _gold <= 0 ? 0 : _gold;
        _daibi = _daibi<= 0 ? 0 :_daibi;
        this.mangguoMoney.string = Utility.currencyFormatting(_gold);
        this.choumaMoney.string = Utility.currencyFormatting(_chip);
        this.daibiMoney.string = Utility.currencyFormatting(_daibi);
    }

    refreshPlayerInfo(roleData: IUserData,isrefresh:boolean = true)
    {
        this.refreshOpen(true);
        this.switcher.SwitchState('player')
        this.centerUISwitch.SwitchState('right')
        this.playerSprite = roleData.avatarSprite

        this.refreshGender(roleData.gender);

        if (this.cacheName == '') {
            this.cacheName = roleData.name;
            this.eidtorBox.string = this.cacheName;
        }

        this.refreshLv(roleData);

        this.refreshVipState(roleData.vipConfigList)
    }

    //vip 更新
    refreshVipState(viplist:any[]){
        for (let index = 0; index < 3; index++) {
            this.updateGrayVipBtn(index,true);
        }
        if (viplist && viplist.length > 0) {
            //控制显示    
            for (let i = 0; i < viplist.length; i++) {
                let data = viplist[i];
                let idx = this.vipMap.get(data.code);
                this.updateGrayVipBtn(idx,!data.remainTime || data.remainTime <= 0)
            }
        }
    }



    private updateGrayVipBtn(index:number,isHide:boolean){
        let vipNode = this.vipNodes[index];
        let grayBtn = this.grayNode[index];
        if (vipNode) {
            vipNode.active = !isHide;
            grayBtn.active = isHide;
        }
    }

    refreshCommon(roleData: IUserData){
        let idstr = "ID:" + roleData.id.toString();
        this.baseInfoID.string = idstr;
        this.refreshPlayerBaseInfoIcon(roleData.avatarSprite)
        this.player_avatar.show(true,roleData.id);

    }

    refreshGender(gender:number){
        this.maskNode[0].active = gender == 2;//女
        this.maskNode[1].active = gender == 1;//男

        let id = ModelData.instance.roleData.id;
        LoaclStorage.setNumber('_player_gender_'+id,gender);
    }

    refreshOpen(isplayer:boolean){
        this.openNode[1].active = !isplayer;
        this.openNode[0].active = isplayer;
    }

    //更新其他玩家信息
    refreshOtherInfo(roleData: IUserData){
        this.refreshOpen(false);
        this.switcher.SwitchState('otherPlayer')
        this.centerUISwitch.SwitchState('center')
        this.otherSex[0].active = roleData.gender == 2;//女
        this.otherSex[1].active = roleData.gender == 1;//男
        this.otherName.string = Utility.filterPlayerName( roleData.name,18);
        let data = this.getLvData(roleData);
        this.otherLv.string = data.lv;

        this.refreshVipState(roleData.vipConfigList)
    }

    refreshLv(roleData: IUserData){
        let data = this.getLvData(roleData);
        this.lv.string = data.lv
        let percent = data.curExp / ((data.totalExp == 0) ? 1:data.totalExp);
        this.sliderMask.setContentSize(percent * 210,30);
        this.exp.string = data.curExp +'/' + data.totalExp;
    }

    getLvData(roleData: IUserData){
        let total = roleData.expNext
        let cur = roleData.expCurrent;
        let lv = 'LV.'+roleData.userLevel;
        if (total == 0 || total == undefined) {
            total = 14;
            cur = 0;
            lv =  'LV.1';
        }
        return {totalExp:total,curExp:cur,lv:lv}
    }

    currencyFormatting(money:number){
        return Math.floor(money * 1000 / 10) / 100
    }

    formatGold(money:number){
        if (money <= 0.001) {
            return '0';
        }
        let _money = this.currencyFormatting(money);
        return Utility.currencyFormatting(_money);
    }

    //最高获胜
    updateMaxVectory(mg:number,cm:number){
        this.maxVectoryCM.string = this.formatGold(cm);
        this.maxVectoryMG.string = this.formatGold(mg);
    }

    //最高历史记录
    updateMaxHistoryGold(mg:number,cm:number){
        this.historyMaxCM.string = this.formatGold(cm);
        this.historyMaxMG.string = this.formatGold(mg);
    }



    updateJS(mg:number,cm:number){
        this.gamescm.string = cm.toString();
        this.gamesmg.string = mg.toString();
    }

    //更新布局
    updateContentLayout(){
        //最高获胜
        this.updateLayout(this.maxVectory)
        //最高历史
        this.updateLayout(this.history)
        //局数
        this.updateLayout(this.jushu)

        this.updateLayout(this.myGold)
    }

    resetCache(){
        if (!this.isPlayerInfoActive()) {
            this.cacheName = ''
        }
    }


    isPlayerInfoActive(){
        let module = ModuleManager.instance.moduleHasActive('PlayerInfoSetting')
        return module;
    }

    private updateLayout(nodes:cc.Node[]){
        nodes[0].active = false//ModelData.instance.showChipCurrency//筹码
        nodes[1].active = true//ModelData.instance.showGoldCurrency//芒果
    }
}
